
import React, { } from 'react';
import './RaiseTicket.css';
import Form from './Form/Form';
import BackButton from '../../../../../application/commons/back-button/back-button';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ErrorPopup from '../Popups/ErrorPopup/ErrorPopup';
import { RootState } from '../../../../../utils/redux-store/appStore';

const RaiseTicket: React.FC = () => {
    const location = useLocation();
    const { ticketData, type } = location.state || {};
    const error_msg =
        "Your servicenow account is not available. Please contact admin to create one";
    const accountExist = useSelector((state: RootState) => state.serviceNowDetails.accountExist);

    return accountExist ? (
        <>
            <div id="back" className="back">
                <BackButton />
            </div>
            <div className="raise_ticket" >
                <div className="raise_image">
                    <div>
                        <div className="bot_logo"></div>
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div className="text1">
                        <p>Raise a {type ? type : 'Ticket'}</p>
                    </div>
                    <div className="text2">
                        <p>{ticketData ? ticketData.short_description : ''}</p>
                    </div>
                    <div className="textbox1">
                        {type !== 'Catalog' && <Form formType={type}></Form>}
                    </div >
                    {
                        type === 'Catalog' && (
                            <div className="textbox1">
                                <h5>Title : {ticketData.title}</h5>
                                <p>Description : {ticketData.description}</p>
                            </div>
                        )
                    }
                </div>
            </div >
        </>
    ) :
        (
            <ErrorPopup error_msg={error_msg} />
        )
};

export default RaiseTicket;

